import React, { Component, Fragment } from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import ServiceIcon from "./ServiceIcon";
import Loader from "./Loader";
import he from "he";

class InfoPanel extends Component {
  render() {
    return (
      <Container>
        {this.props.loading ? (
          <Fragment>
            <Loader />
          </Fragment>
        ) : (
          <Fragment>
            <Title>{this.props.name}</Title>

            <Wrapper>
              {this.props.tags.map((value, index) => (
                <ServiceIcon
                  size={this.props.size}
                  mgn={this.props.mgn}
                  tag={value}
                  key={index}
                />
              ))}
            </Wrapper>

            <Description>{he.decode(this.props.description)}</Description>

            <LinkContainer>
              <Link
                exact
                to="/services"
                onClick={() => this.toggleMobileMenuVisibility()}
              >
                Read More
              </Link>
            </LinkContainer>
          </Fragment>
        )}
      </Container>
    );
  }
}

const Container = styled.div`
  margin: 0;
  padding: 0;
  display: block;
  height: 100%;
  font-family: "Bree Serif", serif;
  position: relative;
`;

const Title = styled.h1`
  color: #ffc300;
  padding: 0 0 5px 0;
  margin: 0;
  font-size: 18px;
  font-weight: normal;
`;

const Link = styled(NavLink)`
  margin: 0;
  padding: 2px 15px;
  color: #000000;
  background: #fdba03;
  text-transform: uppercase;
  font-size: 13px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
`;

const LinkContainer = styled.div`
  display: block;
  text-align: right;
  padding: 0;
  position: absolute;
  bottom: 0px;
  right: 0px;
`;

const Wrapper = styled.div`
  padding: 0;
  margin-bottom: 10px;
`;

const Description = styled.p`
  color: #ffffff;
  font-weight: 300;
  margin: 0 0 5px 0;
  padding: 0 0 25px 0;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
`;

export default InfoPanel;



// WEBPACK FOOTER //
// ./src/components/InfoPanel.js